"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityHCImage',
  props: {
    pageKey: {
      type: String,
      default: 'communityHome'
    },
    moduleKey: {
      type: String,
      default: '10-1'
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;
    return {
      imagePrefix: '',
      list: [],
      selectedItems: [],
      // 用于预览功能的选中项
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      dialogTitle: '添加图片',
      isEdit: false,
      currentId: null,
      // 预览相关变量
      previewVisible: false,
      previewImageUrl: '',
      formData: {
        dateRange: [],
        title: '',
        url: '',
        signUp: true,
        onShelf: true,
        sort: 1,
        startTime: '',
        endTime: '',
        visible: true,
        desc: '',
        // 新增说明
        type: 'normal',
        // 新增类型
        detailImages: [],
        // 新增详情图
        urlInput: '' // 新增链接URL
      },
      detailFiles: [],
      // el-upload 用于绑定文件列表
      rules: {
        url: [{
          required: true,
          message: '请上传图片',
          trigger: 'change',
          validator: function validator(rule, value, callback) {
            // 只有在类型为normal时才需要上传图片
            if (_this.formData.type === 'normal' && !value) {
              callback(new Error('请上传图片'));
            } else {
              callback();
            }
          }
        }],
        title: [{
          required: true,
          message: '请输入主题',
          trigger: 'blur'
        }],
        urlInput: [{
          required: true,
          message: '请输入URL',
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.formData.type === 'link' && !value) {
              callback(new Error('请输入URL'));
            } else {
              callback();
            }
          }
        }],
        dateRange: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change',
          validator: function validator(rule, value, callback) {
            if (!value || value.length !== 2 || !value[0] || !value[1]) {
              callback(new Error('请选择活动时间'));
            } else {
              callback();
            }
          }
        }]
      },
      systemPages: [{
        label: '首页',
        value: 'home'
      }, {
        label: '普通专区页',
        value: 'normalArea'
      }, {
        label: '充值页',
        value: 'topUp'
      }, {
        label: '会员中心',
        value: 'memberCenter'
      }],
      plates: [{
        label: '首页Banner',
        value: 'homeBanner'
      }, {
        label: '社区活动',
        value: 'community'
      }],
      recommendTypes: [{
        label: '系统页面',
        value: 'system'
      }, {
        label: '自定义',
        value: 'custom'
      }],
      jumpPages: [{
        label: '首页',
        value: 'home'
      }, {
        label: '充值',
        value: 'topUp'
      }, {
        label: '普通专区',
        value: 'normalArea'
      }]
    };
  },
  created: function created() {
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取图片前缀
    this.getImagePrefix();
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    handleAdd: function () {
      var _handleAdd = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.dialogTitle = '添加图片';
              this.isEdit = false;
              this.dialogVisible = true;
              this.resetForm();
              this.detailFiles = [];
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleAdd() {
        return _handleAdd.apply(this, arguments);
      }
      return handleAdd;
    }(),
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var loadingInstance, response, detailData, extraData, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingInstance = null;
              _context3.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置项详情
              _context3.next = 2;
              return (0, _decorateConfigItem.getConfigItemDetail)(row.id);
            case 2:
              response = _context3.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                extraData = detailData.extra ? JSON.parse(detailData.extra) : {};
                this.dialogTitle = '编辑图片';
                this.isEdit = true;
                this.currentId = detailData.id;
                this.dialogVisible = true;

                // 填充表单数据
                this.formData = {
                  title: extraData.title || '',
                  url: extraData.url || '',
                  signUp: extraData.signUp !== undefined ? extraData.signUp : true,
                  onShelf: extraData.onShelf !== undefined ? extraData.onShelf : true,
                  sort: extraData.sort !== undefined ? extraData.sort : 1,
                  startTime: extraData.startTime || '',
                  endTime: extraData.endTime || '',
                  visible: extraData.visible !== undefined ? extraData.visible : true,
                  desc: extraData.desc || '',
                  type: extraData.type || 'normal',
                  urlInput: extraData.urlInput || '',
                  detailImages: extraData.detailImages ? [].concat(extraData.detailImages) : []
                };

                // 设置日期范围
                if (extraData.startTime && extraData.endTime) {
                  this.formData.dateRange = [extraData.startTime, extraData.endTime];
                } else {
                  this.formData.dateRange = [];
                }

                // 如果有详情图，初始化文件列表
                if (this.formData.detailImages && this.formData.detailImages.length > 0) {
                  this.detailFiles = this.formData.detailImages.map(function (src, i) {
                    return {
                      url: src,
                      name: "\u56FE\u7247".concat(i + 1),
                      status: 'finished'
                    };
                  });
                } else {
                  this.detailFiles = [];
                }
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t2 = _context3["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t2);
              this.$message.error('加载详情失败: ' + (_t2.message || '未知错误'));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleRemove: function () {
      var _handleRemove = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm('确定要移除该图片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var response, _t3;
                return regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      _context4.next = 1;
                      return (0, _decorateConfigItem.deleteConfigItem)(row.id);
                    case 1:
                      response = _context4.sent;
                      if (!(response.code === 200)) {
                        _context4.next = 3;
                        break;
                      }
                      _context4.next = 2;
                      return _this2.loadConfig();
                    case 2:
                      _this2.$message.success('移除成功');
                      _context4.next = 4;
                      break;
                    case 3:
                      _this2.$message.error(response.message || '删除失败!');
                    case 4:
                      _context4.next = 6;
                      break;
                    case 5:
                      _context4.prev = 5;
                      _t3 = _context4["catch"](0);
                      console.error('删除失败:', _t3);
                      _this2.$message.error('删除失败: ' + (_t3.message || '未知错误'));
                    case 6:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[0, 5]]);
              }))).catch(function () {});
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleRemove(_x2) {
        return _handleRemove.apply(this, arguments);
      }
      return handleRemove;
    }(),
    handleToggleVisible: function () {
      var _handleToggleVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context6.sent;
              if (!(response.code === 200)) {
                _context6.next = 3;
                break;
              }
              _context6.next = 2;
              return this.loadConfig();
            case 2:
              this.$message.success("\u66F4\u65B0\u6210\u529F");
              _context6.next = 4;
              break;
            case 3:
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              this.$message.error(response.message || '操作失败!');
            case 4:
              _context6.next = 6;
              break;
            case 5:
              _context6.prev = 5;
              _t4 = _context6["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.enable = !row.enable;
              console.error('操作失败:', _t4);
              this.$message.error('操作失败: ' + (_t4.message || '未知错误'));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 5]]);
      }));
      function handleToggleVisible(_x3) {
        return _handleToggleVisible.apply(this, arguments);
      }
      return handleToggleVisible;
    }(),
    triggerSelect: function triggerSelect() {
      this.$refs.fileInput.click();
    },
    handleFileChange: function () {
      var _handleFileChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(event) {
        var file, _loading, response, imageUrl, _t5;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              file = event.target.files && event.target.files[0];
              if (file) {
                _context7.next = 1;
                break;
              }
              return _context7.abrupt("return");
            case 1:
              if (this.validateImage(file)) {
                _context7.next = 2;
                break;
              }
              event.target.value = '';
              return _context7.abrupt("return");
            case 2:
              _context7.prev = 2;
              // 显示上传loading状态
              _loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口上传图片
              _context7.next = 3;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 3:
              response = _context7.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200) {
                imageUrl = response.data;
                this.formData.url = imageUrl;
                this.$message.success('图片上传成功!');
              } else {
                this.$message.error(response.message || '图片上传失败!');
              }
              _context7.next = 5;
              break;
            case 4:
              _context7.prev = 4;
              _t5 = _context7["catch"](2);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('图片上传失败:', _t5);
              this.$message.error('图片上传失败: ' + (_t5.message || '未知错误'));
            case 5:
              event.target.value = '';
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[2, 4]]);
      }));
      function handleFileChange(_x4) {
        return _handleFileChange.apply(this, arguments);
      }
      return handleFileChange;
    }(),
    validateImage: function validateImage(file) {
      var isImage = file.type && file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 处理类型切换
    handleTypeChange: function handleTypeChange() {
      var _this3 = this;
      // 清除之前的验证错误
      this.$nextTick(function () {
        if (_this3.$refs.form) {
          _this3.$refs.form.clearValidate(['url', 'urlInput']);
        }
      });
    },
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _this4 = this;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(valid) {
                  var loadingInstance, data, response, _t6;
                  return regeneratorRuntime.wrap(function (_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (valid) {
                          _context8.next = 1;
                          break;
                        }
                        return _context8.abrupt("return");
                      case 1:
                        // 同步日期范围到formData
                        if (_this4.formData.dateRange && _this4.formData.dateRange.length === 2) {
                          _this4.formData.startTime = _this4.formData.dateRange[0];
                          _this4.formData.endTime = _this4.formData.dateRange[1];
                        } else {
                          _this4.formData.startTime = '';
                          _this4.formData.endTime = '';
                        }
                        loadingInstance = null;
                        _context8.prev = 2;
                        data = {
                          id: _this4.isEdit ? _this4.currentId : null,
                          pageCode: _this4.pageKey,
                          optionCode: _this4.moduleKey,
                          title: _this4.formData.title,
                          enable: _this4.formData.onShelf,
                          extra: JSON.stringify({
                            title: _this4.formData.title,
                            url: _this4.formData.url,
                            signUp: _this4.formData.signUp,
                            onShelf: _this4.formData.onShelf,
                            sort: _this4.formData.sort,
                            startTime: _this4.formData.startTime,
                            endTime: _this4.formData.endTime,
                            visible: _this4.formData.visible,
                            desc: _this4.formData.desc,
                            type: _this4.formData.type,
                            urlInput: _this4.formData.urlInput,
                            detailImages: _this4.formData.detailImages
                          })
                        }; // 显示保存loading状态
                        loadingInstance = _this4.$loading({
                          lock: true,
                          text: '保存中...',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 调用后端接口保存配置
                        _context8.next = 3;
                        return (0, _decorateConfigItem.saveConfigItem)(data);
                      case 3:
                        response = _context8.sent;
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        if (!(response.code === 200)) {
                          _context8.next = 5;
                          break;
                        }
                        // 保存成功后关闭对话框
                        _this4.dialogVisible = false;
                        // 刷新列表数据
                        _context8.next = 4;
                        return _this4.loadConfig();
                      case 4:
                        _this4.$message.success(_this4.isEdit ? '编辑成功' : '添加成功');
                        _context8.next = 6;
                        break;
                      case 5:
                        _this4.$message.error(response.message || '保存失败!');
                      case 6:
                        _context8.next = 8;
                        break;
                      case 7:
                        _context8.prev = 7;
                        _t6 = _context8["catch"](2);
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        console.error('保存失败:', _t6);
                        _this4.$message.error('保存失败: ' + (_t6.message || '未知错误'));
                      case 8:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8, null, [[2, 7]]);
                }));
                return function (_x5) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    resetForm: function resetForm() {
      this.currentId = null;
      this.dateRange = [];
      this.formData = {
        title: '',
        url: '',
        signUp: true,
        onShelf: true,
        sort: 1,
        startTime: '',
        endTime: '',
        visible: true,
        desc: '',
        type: 'normal',
        urlInput: '',
        detailImages: []
      };
      this.detailFiles = [];
      if (this.$refs.form) this.$refs.form.clearValidate();
    },
    // el-upload 细节图 handler
    handleDetailImageChange: function () {
      var _handleDetailImageChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(file, fileList) {
        var _loading2, response, imageUrl, index, _index, _t7;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              if (!(file.status === 'ready')) {
                _context0.next = 5;
                break;
              }
              _context0.prev = 1;
              // 显示上传loading状态
              _loading2 = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口上传图片
              _context0.next = 2;
              return (0, _popupConfig.uploadPopupImage)(file.raw);
            case 2:
              response = _context0.sent;
              // 关闭loading
              _loading2.close();
              if (response.code === 200) {
                imageUrl = response.data; // 更新文件列表中的URL
                file.url = imageUrl;
                file.status = 'finished';

                // 更新formData中的详情图
                this.formData.detailImages = fileList.map(function (f) {
                  return f.url || f.response && f.response.url || f.rawUrl;
                }).filter(Boolean);
                this.detailFiles = fileList;
                this.$message.success('图片上传成功!');
              } else {
                this.$message.error(response.message || '图片上传失败!');
                // 移除上传失败的文件
                index = fileList.findIndex(function (f) {
                  return f.uid === file.uid;
                });
                if (index > -1) {
                  fileList.splice(index, 1);
                }
              }
              _context0.next = 4;
              break;
            case 3:
              _context0.prev = 3;
              _t7 = _context0["catch"](1);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('图片上传失败:', _t7);
              this.$message.error('图片上传失败: ' + (_t7.message || '未知错误'));

              // 移除上传失败的文件
              _index = fileList.findIndex(function (f) {
                return f.uid === file.uid;
              });
              if (_index > -1) {
                fileList.splice(_index, 1);
              }
            case 4:
              _context0.next = 6;
              break;
            case 5:
              // 只存base64或url
              this.detailFiles = fileList;
              this.formData.detailImages = fileList.map(function (f) {
                return f.url || f.response && f.response.url || f.rawUrl;
              }).filter(Boolean);
            case 6:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[1, 3]]);
      }));
      function handleDetailImageChange(_x6, _x7) {
        return _handleDetailImageChange.apply(this, arguments);
      }
      return handleDetailImageChange;
    }(),
    handleDetailImageRemove: function handleDetailImageRemove(file, fileList) {
      this.detailFiles = fileList;
      this.formData.detailImages = fileList.map(function (f) {
        return f.url || f.response && f.response.url || f.rawUrl;
      }).filter(Boolean);
    },
    handleDetailImagePreview: function handleDetailImagePreview(file) {
      window.open(file.url || file.response && file.response.url || file.rawUrl, '_blank');
    },
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var loadingInstance, response, _t8;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              loadingInstance = null;
              _context1.prev = 1;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context1.next = 2;
                break;
              }
              return _context1.abrupt("return");
            case 2:
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置
              _context1.next = 3;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize);
            case 3:
              response = _context1.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 解析配置信息
                this.list = response.records.map(function (item) {
                  var extra = item.extra ? JSON.parse(item.extra) : {};
                  return _objectSpread(_objectSpread({}, item), extra);
                });
                this.total = response.total;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              _context1.next = 5;
              break;
            case 4:
              _context1.prev = 4;
              _t8 = _context1["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t8);
              this.$message.error('配置加载失败: ' + (_t8.message || '未知错误'));
            case 5:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[1, 4]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('社区图片配置保存成功');
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 处理表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedItems = selection;
    },
    // 预览功能
    preview: function () {
      var _preview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var loadingInstance, ids, previewData, response, _t9;
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(this.selectedItems.length === 0)) {
                _context11.next = 1;
                break;
              }
              this.$message.warning('请至少选择一条数据进行预览');
              return _context11.abrupt("return");
            case 1:
              loadingInstance = null;
              _context11.prev = 2;
              // 获取选中数据的ID
              ids = this.selectedItems.map(function (item) {
                return item.id;
              }); // 构造预览参数
              previewData = {
                ids: ids,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                xcxType: this.xcxType,
                pageURl: "" // 设置默认页面URL，可根据实际需求调整
              }; // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '预览生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用预览接口
              _context11.next = 3;
              return (0, _decorateConfig.previewAdd)(previewData);
            case 3:
              response = _context11.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有二维码URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了二维码URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('预览二维码生成成功');
                  }
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context11.next = 5;
              break;
            case 4:
              _context11.prev = 4;
              _t9 = _context11["catch"](2);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('预览失败:', _t9);
              this.$message.error('预览失败: ' + (_t9.message || '未知错误'));
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[2, 4]]);
      }));
      function preview() {
        return _preview.apply(this, arguments);
      }
      return preview;
    }()
  }, "handlePreviewClose", function handlePreviewClose() {
    this.previewVisible = false;
    // 释放图片URL对象
    if (this.previewImageUrl) {
      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }
  }), "beforeDestroy", function beforeDestroy() {
    // 释放图片URL对象
    if (this.previewImageUrl) {
      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }
  }), "handlePreview", function () {
    var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(row) {
      var _loading3, response, _t0;
      return regeneratorRuntime.wrap(function (_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            // 显示预览loading状态
            _loading3 = this.$loading({
              lock: true,
              text: '预览中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            }); // 调用后端接口预览配置 第二个参数小程序标识
            _context12.next = 1;
            return (0, _decorateConfigItem.generateQrCode)(row.id, this.xcxType);
          case 1:
            response = _context12.sent;
            // 关闭loading
            _loading3.close();
            if (response.code === 200) {
              // 预览成功，显示返回的图片
              if (response.data && response.data.image) {
                // 显示预览弹窗
                this.previewImageUrl = response.data.image;
                this.previewVisible = true;
              } else {
                this.$message.success('预览成功');
              }
            } else {
              this.$message.error(response.message || '预览失败!');
            }
            _context12.next = 3;
            break;
          case 2:
            _context12.prev = 2;
            _t0 = _context12["catch"](0);
            // 关闭loading
            if (loading) {
              loading.close();
            }
            console.error('预览失败:', _t0);
            this.$message.error('预览失败: ' + (_t0.message || '未知错误'));
          case 3:
          case "end":
            return _context12.stop();
        }
      }, _callee12, this, [[0, 2]]);
    }));
    function handlePreview(_x8) {
      return _handlePreview.apply(this, arguments);
    }
    return handlePreview;
  }())
};